
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contribution/[[...fund]]",
      function () {
        return require("private-next-pages/contribution/[[...fund]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contribution/[[...fund]]"])
      });
    }
  